export const ADDRESS_CREATING = 'ADDRESS_CREATING'
export const ADDRESS_CREATE_SUCCESS = 'ADDRESS_CREATE_SUCCESS'
export const ADDRESS_CREATE_ERROR = 'ADDRESS_CREATE_ERROR'